export const configAscScaleLayer = {
  "Name" : "ASCScale",
  "Renderer" : "ASCScaleExt",
  "Attributes" : {
    "style" : {
      "default" : {
        "min_blocksize":1,
        "turb_sev_color":"rgba(255,0,0,0.5)",//#FF0000
        "turb_mod_to_sev_color":"rgba(255,105,180,0.5)",//#ff69b4
        "turb_mod_color":"rgba(255,182,193,0.5)",//#ffb6c1
        "conv_mod_color":"rgba(0,128,0,0.5)",//#008000
        "conv_lgt_color":"rgba(152,251,152,0.5)",//#98fb98
        "icing_mod_color":"rgba(0,0,255,0.5)",//#0000ff
        "icing_lgt_color":"rgba(0,255,255,0.5)"//#00ffff
      }
    }
  }
};